import { Component } from '@verndale/core';

class TabbedBlock extends Component {
  setupDefaults() {
    this.dom = {
      tabs: this.el.querySelectorAll('.tabbed-block__tab'),
      tabPanels: this.el.querySelectorAll('.tabbed-block__tab-panel')
    };
    this.showActivePanel(this.dom.tabs[0].getAttribute('aria-controls'));
  }

  addListeners() {
    this.dom.tabs.forEach(tab => {
      tab.addEventListener('click', this.handleTabClick.bind(this));
      tab.addEventListener('keydown', e => {
        if (e.code === 'Enter') {
          this.handleTabClick(e);
        }
      });
    });
  }

  hideAllPanels() {
    this.dom.tabPanels.forEach(panel => {
      panel.hidden = true;
    });
    this.dom.tabs.forEach(tab => {
      tab.classList.remove('tabbed-block__tab--active');
    });
  }

  showActivePanel(tabId) {
    this.dom.tabPanels.forEach(panel => {
      if (panel.id === tabId) panel.hidden = false;
    });
    this.dom.tabs.forEach(tab => {
      if (tab.getAttribute('aria-controls') === tabId)
        tab.classList.add('tabbed-block__tab--active');
    });
  }

  handleTabClick(e) {
    const tab = e.currentTarget;
    const tabId = tab.getAttribute('aria-controls');
    this.hideAllPanels();
    this.showActivePanel(tabId);
  }
}

export default TabbedBlock;
